export type BuilderPhoneDialOption = {
  dial: string
  country: string | null
}

export const BUILDER_PHONE_DIAL_OPTIONS: readonly BuilderPhoneDialOption[] = [
  { dial: '+370', country: 'lt' },
  { dial: '+371', country: 'lv' },
  { dial: '+372', country: 'ee' },
  { dial: '+48', country: 'pl' },
  { dial: '+46', country: 'se' },
  { dial: '+44', country: 'gb' },
  { dial: '+49', country: 'de' },
  { dial: '+', country: null },
]

export function defaultBuilderPhoneDial(language: string): string {
  if (language.startsWith('lt')) return '+370'
  if (language.startsWith('lv')) return '+371'
  if (language.startsWith('et')) return '+372'
  if (language.startsWith('pl')) return '+48'
  if (language.startsWith('de')) return '+49'
  return '+370'
}

export function composeSellerPhone(dialCode: string, national: string): string {
  const raw = national.trim()
  if (!raw) return ''
  if (raw.startsWith('+')) return raw.replace(/\s/g, '')
  const prefix = dialCode === '+' ? '+' : dialCode
  const digits = raw.replace(/\s/g, '')
  return `${prefix}${digits.replace(/^0+/, '')}`
}

export function dialOptionForCode(dial: string): BuilderPhoneDialOption | undefined {
  return BUILDER_PHONE_DIAL_OPTIONS.find((o) => o.dial === dial)
}

export function dialFlagCountry(dial: string): string | null {
  return dialOptionForCode(dial)?.country ?? null
}

export function flagCdnSrc(country: string, width: 20 | 40 = 20): string {
  return `https://flagcdn.com/w${width}/${country}.png`
}

export function dialOptionLabel(option: BuilderPhoneDialOption): string {
  return option.dial
}
